import React from 'react'
import { withTranslation } from "react-i18next";
import images from 'ressources/images';

const Error = ({t}) => {
    const params = (new URL(document.location)).searchParams;
    const error = params.get('error');

    return (
    <div className='max-w'>
        <img src={images.warning} alt="" width="100" height="100" />
        <p class="text mt">{t(error) }</p>
    </div>
  )
}

export default withTranslation()(Error)
